import {WatchQueryFetchPolicy} from "@apollo/client";
import {useState} from "react";

const lastNetworkFetch: Record<string, number> = {};

/**
 * LayoutStandard wird bei jedem Bereichswechsel neu gemountet. Mit
 * `cache-and-network` fragt jede Navigation Rollen, Widerrufe usw. erneut ab
 * (Prod 19.10.2026: Tausende Anfragen in 2 h). Dieser Hook fragt höchstens
 * einmal pro `maxAgeMs` und Tab beim Server nach; dazwischen gilt `cache-first`.
 *
 * Die Entscheidung fällt einmal pro Mount: Ändert sich die fetchPolicy eines
 * gemounteten useQuery, stößt Apollo eine neue Anfrage an.
 */
export const useThrottledFetchPolicy = (key: string, maxAgeMs: number): WatchQueryFetchPolicy => {
    const [fetchPolicy] = useState<WatchQueryFetchPolicy>(() => {
        const now = Date.now();

        if (now - (lastNetworkFetch[key] ?? 0) < maxAgeMs) return "cache-first";
        lastNetworkFetch[key] = now;

        return "cache-and-network";
    });

    return fetchPolicy;
};
